import React from 'react';
import { _, mui } from '@local/finsera-core/src/libs';

const DENISTY_OPTIONS: { icon: React.ReactNode; value: mui.dataGrid.GridDensity }[] = [
  { icon: <mui.icons.DensitySmall fontSize="small" />, value: 'compact' },
  { icon: <mui.icons.DensityMedium fontSize="small" />, value: 'standard' },
  { icon: <mui.icons.DensityLarge fontSize="small" />, value: 'comfortable' },
];

const DensityFilter = () => {
  const apiRef = mui.dataGrid.useGridApiContext();
  const density = mui.dataGrid.useGridSelector(apiRef, mui.dataGrid.gridDensitySelector);
  const [densityMenuOpen, setDensityMenuOpen] = React.useState(false);
  const densityMenuTriggerRef = React.useRef<HTMLButtonElement>(null);

  return (
    <>
      <mui.dataGrid.ToolbarButton
        id="density-menu-trigger"
        aria-controls="density-menu"
        aria-haspopup="true"
        aria-expanded={densityMenuOpen ? 'true' : undefined}
        render={() => (
          <mui.core.Button
            ref={densityMenuTriggerRef}
            size="small"
            sx={{ border: '0px!important', padding: '0 4px!important' }}
            onClick={() => setDensityMenuOpen(true)}
          >
            Density
          </mui.core.Button>
        )}
      />
      <mui.core.Menu
        id="density-menu"
        anchorEl={densityMenuTriggerRef.current}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={densityMenuOpen}
        onClose={() => setDensityMenuOpen(false)}
        slotProps={{
          list: {
            'aria-labelledby': 'density-menu-trigger',
          },
        }}
      >
        {DENISTY_OPTIONS.map((option) => (
          <mui.core.MenuItem
            key={option.value}
            onClick={() => {
              apiRef.current.setDensity(option.value);
              setDensityMenuOpen(false);
            }}
            selected={option.value === density}
            sx={{
              gap: 2,
              fontWeight: 500,
            }}
          >
            {option.icon}
            {_.startCase(option.value)}
          </mui.core.MenuItem>
        ))}
      </mui.core.Menu>
    </>
  );
};

export default DensityFilter;
